module.exports = __webpack_public_path__ + "img/wx.a6593be.svg";